
  import * as cloudflareRuntime$_uLNKE1ozkoBFadG0fVu5Ggw4rUBYOm5tHvMWdQaVro from '/opt/buildhome/repo/node_modules/@nuxt/image/dist/runtime/providers/cloudflare'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {
    "featured": {
      "modifiers": {
        "fit": "cover",
        "width": 1200,
        "height": 800
      }
    },
    "thumbnail": {
      "modifiers": {
        "fit": "cover",
        "width": 400,
        "height": 400
      }
    }
  },
  "provider": "cloudflare",
  "domains": [
    "cms.idrewfilm.com",
    "idrewfilm.com"
  ],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp",
    "webp"
  ],
  "quality": 80
},
    providers: {
        ['cloudflare']: { provider: cloudflareRuntime$_uLNKE1ozkoBFadG0fVu5Ggw4rUBYOm5tHvMWdQaVro, defaults: {"baseURL":"https://idrewfilm.com"} }
    }
  }
